import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import YouTube from "react-youtube";

/**
 * Video Modal Component
 * Shadcn Dialog wrapper for YouTube video player
 */
function UserVideoModal({ open, onOpenChange, videoId, videoName, onClose }) {
    const opts = {
        height: '100%',
        width: '100%',
        playerVars: {
            autoplay: 1,
        },
    };

    const handleReady = (event) => {
        const player = event.target;
        player.playVideo();
    };

    const handleOpenChange = (isOpen) => {
        if (!isOpen && onClose) {
            onClose();
        }
        onOpenChange(isOpen);
    };

    return (
        <Dialog open={open} onOpenChange={handleOpenChange}>
            <DialogContent className="max-w-4xl w-full p-0">
                <DialogHeader className="p-6 pb-4">
                    <DialogTitle className="text-xl font-semibold text-foreground">
                        {videoName || 'Training Video'}
                    </DialogTitle>
                </DialogHeader>
                <div className="px-6 pb-6">
                    <div className="relative w-full" style={{ paddingBottom: '56.25%' }}>
                        <div className="absolute inset-0">
                            <YouTube
                                videoId={videoId}
                                opts={opts}
                                onReady={handleReady}
                                className="w-full h-full"
                                iframeClassName="w-full h-full rounded-md"
                            />
                        </div>
                    </div>
                </div>
            </DialogContent>
        </Dialog>
    );
}

export default UserVideoModal;
